// Helper function to convert amount to wei (assuming 18 decimals for most tokens)
export const convertToWei = (amount, decimals = 18) => {
    const amountFloat = parseFloat(amount)
    if (isNaN(amountFloat)) return '0'
    // Convert to wei by multiplying by 10^decimals
    const weiAmount = (amountFloat * Math.pow(10, decimals)).toString()
    return weiAmount
}

// Normalize various network identifiers to lowercase for API: 'polygon' | 'ethereum'
 export  const normalizeNetwork = (net) => {
  if (net === undefined || net === null) return 'polygon'
  const n = net.toString().trim().toLowerCase()
  if (['polygon', 'matic', 'pol', '137', 'polugon', 'polygon mainnet', 'polygon pos'].includes(n)) return 'polygon'
  if (['ethereum', 'eth', 'mainnet', '1', 'ehteriym', 'ethereum mainnet'].includes(n)) return 'ethereum'
  return null
}

// Helper function to display network name properly
export const getDisplayNetworkName = (net) => {
  const normalized = normalizeNetwork(net)
  if (normalized === 'polygon') return 'Polygon'
  if (normalized === 'ethereum') return 'Ethereum'
  return 'Unsupported'
}

// Helper function to get blockchain explorer URL for transaction
export const getExplorerUrl = (txHash, network = 'polygon') => {
  if (!txHash) return null

  const normalized = normalizeNetwork(network)

  switch (normalized) {
    case 'polygon':
      return `https://polygonscan.com/tx/${txHash}`
    case 'ethereum':
      return `https://etherscan.io/tx/${txHash}`
    default:
      return `https://polygonscan.com/tx/${txHash}` // Default to Polygon
  }
}

// Helper function to open transaction in blockchain explorer
export const openTransactionInExplorer = (txHash, network = 'polygon') => {
  const url = getExplorerUrl(txHash, network);
  if (url) {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}

// Helper function to convert Wei to Ether (or native token)
export const weiToEther = (wei, decimals = 18) => {
  if (!wei) return '0';
  const weiStr = wei.toString();
  
  // Pad with zeros if needed
  const paddedWei = weiStr.padStart(decimals + 1, '0');
  
  // Split into integer and decimal parts
  const integerPart = paddedWei.slice(0, -decimals) || '0';
  const decimalPart = paddedWei.slice(-decimals);
  
  // Remove trailing zeros from decimal part
  const trimmedDecimal = decimalPart.replace(/0+$/, '');
  
  if (trimmedDecimal) {
    return `${integerPart}.${trimmedDecimal}`;
  }
  return integerPart;
}

// Helper function to format gas cost for display
export const formatGasCost = (totalCostWei, network = 'polygon', decimals = 18) => {
  const ether = weiToEther(totalCostWei, decimals);
  const etherFloat = parseFloat(ether);
  
  // Get native token symbol based on network
  const symbol = normalizeNetwork(network) === 'ethereum' ? 'ETH' : 'MATIC';
  
  // Format with appropriate precision
  if (etherFloat < 0.0001) {
    return `< 0.0001 ${symbol}`;
  } else if (etherFloat < 1) {
    return `${etherFloat.toFixed(6)} ${symbol}`;
  } else {
    return `${etherFloat.toFixed(4)} ${symbol}`;
  }
}